<template>
  <div class="va-row">
    <div class="flex md12 xs12">
      <vuestic-data-table
        class="text-center"
        :apiMode="true"
        :apiUrl="apiUrl"
        :httpOptions="httpOptions"
        :defaultPerPage="defaultTablePerPage"
        :tableFields="tableFields"
        :actions="true"
        :actionsType="'extensions'"
        :additionalActions="true"
      >
        <template slot="additionalTableControl">
          <router-link
            class="btn btn-micro btn-primary rounded"
            :to="{ name: 'extension-create' }"
          >
            <i class="ion-md-add ion"></i> {{ $t('buttons.create') }}
          </router-link>
        </template>
      </vuestic-data-table>
    </div>
    <app-filterbar
      v-on:apply-filters="applyFilters"
      v-on:reset-filters="resetFilters"
    >
      <template slot="filterbar-content">
        <div class="filterbar-input">
          <p class="filter-selector">
            <!-- <input
              type="checkbox"
              id="extension_number"
              v-model="filterByExtensions"
            /> -->
            Extension number
          </p>
          <vuestic-multi-select
            v-model="filteredExtensions"
            :options="extensionNumbers"
            :optionKey="'ext'"
            pholder="Choose Extension No."
          />
        </div>
        <div class="filterbar-input">
          <p class="filter-selector">Status:</p>
          <label for="active_status">
            <input
              type="checkbox"
              id="active_status"
              v-model="filterByActiveStatus"
            />
            Active
          </label>
          <label for="inactive_status">
            <input
              type="checkbox"
              id="inactive_status"
              v-model="filterByInactiveStatus"
            />
            Inactive
          </label>
        </div>
      </template>
    </app-filterbar>
  </div>
</template>

<script>
import Vue from 'vue'
import AppFilterbar from '@/components/admin/app-filterbar/AppFilterbar'
import ExtensionStatus from './components/extension-status'
Vue.component('extension-status', ExtensionStatus)
import { mapGetters, mapActions } from 'vuex'
export default {
  components: {
    AppFilterbar,
    // eslint-disable-next-line vue/no-unused-components
    ExtensionStatus
  },
  data() {
    return {
      httpOptions: {
        headers: { Authorization: 'Bearer ' + localStorage.getItem('cTok') }
      },
      filterByExtensions: false,
      filterByActiveStatus: false,
      filterByInactiveStatus: false,
      filteredExtensions: [],
      filter: {
        extensions: '',
        status: ''
      },
      tableFields: [
        {
          name: 'name',
          title: 'Name'
        },
        {
          name: 'ext',
          title: 'Extension No.'
        },
        {
          name: 'email',
          title: 'Email'
        },
        {
          name: 'created_at',
          title: 'Creation Date'
        },
        {
          name: 'updated_at',
          title: 'Last Updated'
        },
        {
          name: '__component:extension-status',
          title: 'Status'
        },
        {
          name: '__slot:extensions_actions',
          title: 'Actions'
        }
      ],
      defaultTablePerPage: 10
    }
  },
  watch: {
    filterByActiveStatus(val) {
      if (val) {
        this.filterByInactiveStatus = false
      }
    },
    filterByInactiveStatus(val) {
      if (val) {
        this.filterByActiveStatus = false
      }
    }
  },
  computed: {
    ...mapGetters(['currentAccount', 'allExtensions']),
    apiUrl() {
      return `${process.env.VUE_APP_WEBSITE_URL}sip/provisioningwa/api/v2/tenant/extension/list/mine?tenant_id=${this.currentAccount.id}&status=${this.filter.status}&extensions=${this.filter.extensions}`
    },
    extensionNumbers() {
      return this.allExtensions
    }
  },
  methods: {
    ...mapActions(['fetchAllExtensions']),
    openPopup() {
      this.$store.dispatch('togglePopup', true)
    },
    async openFilterbar() {
      if (this.allExtensions.length === 0) {
        await this.$store.dispatch('fetchAllExtensions')
      }
      this.extensionNumbers = this.allExtensions
      this.$store.dispatch('toggleFilterbar', true)
    },
    applyFilters() {
      if (this.filteredExtensions.length > 0) {
        this.filter.extensions = this.filteredExtensions
          .map(ex => ex.id)
          .join(',')
      } else {
        this.filter.extensions = ''
      }
      let status = this.filterByActiveStatus
        ? true
        : this.filterByInactiveStatus
        ? false
        : ''
      this.filter.status = status
    },
    resetFilters() {
      this.filterByExtensions = false
      this.filteredExtensions = []
      this.filterByInactiveStatus = false
      this.filterByActiveStatus = false
      this.filter = {
        extensions: '',
        status: ''
      }
    }
  }
}
</script>
